<template>
  <!-- 新增协议 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="850px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.system.text32')" prop="functionCode">
          <el-select
            v-model="ruleForm.functionCode"
            :placeholder="$t('button.pleaseSelect')"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text36')" prop="agreementName">
          <el-input
            v-model="ruleForm.agreementName"
            :disabled="dialogStatus == 2"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text48')">
          <el-radio-group v-model="ruleForm.agreementFlag" :disabled="dialogStatus == 2">
            <el-radio :label="0">{{$t('public.text11')}}</el-radio>
            <el-radio :label="1">{{$t('public.text12')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="ruleForm.agreementFlag == 0">
          <DiluEditor
            v-model="ruleForm.richTextContent"
            :value="ruleForm.richTextContent"
            :disabled="dialogStatus == 2"
          />
        </el-form-item>
        <el-form-item v-else>
          <el-input
            v-model="ruleForm.contentLink"
            :disabled="dialogStatus == 2"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        dialogStatus == 2 ? $t("button.close") : $t("button.cancel")
      }}</el-button>
      <el-button v-if="dialogStatus != 2" type="primary" @click="submit">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import DiluEditor from "../../../../components/pubilc/dilu-ue.vue";
import { validatName } from "../../../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: this.$t("pages.system.text41"),
      ruleForm: {
        agreementName: "", //协议名称
        belongCustomerId: "", //客户id
        functionCode: "", //应用路径
        richTextContent: "", //富文本内容
        appCode: "",
        contentLink: "",
        agreementFlag: 0,
      },
      ischange: false,
      rules: {
        agreementName: [{ validator: validatName, trigger: "blur" }],
        functionCode: {
          required: true,
          message: this.$t("pages.system.text42"),
          trigger: "blur",
        },
        // richTextContent: {
        //   required: true,
        //   message: this.$t("pages.system.text49"),
        //   trigger: "blur",
        // },
      },
    };
  },
  components: {
    DiluEditor,
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.dialogStatus == 1) {
          this.title = this.$t("pages.system.text50");
        }
        if (this.dialogStatus == 2) {
          this.title = this.$t("pages.system.text51");
        }
        if (this.dialogStatus == 0) {
          this.title = this.$t("pages.system.text52");
        }
        if (this.dialogStatus != 0) {
          this.ruleForm = {
            agreementName: this.currentAgreement.agreementName, //协议名称
            belongCustomerId: this.currentAgreement.belongCustomerId, //客户id
            functionCode: this.currentAgreement.functionCode, //应用路径
            richTextContent: this.currentAgreement.richTextContent, //富文本内容
            id: this.currentAgreement.id,
            contentLink: this.currentAgreement.contentLink,
            agreementFlag: this.currentAgreement.agreementFlag,
          };
        }
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["dialogVisible", "options", "dialogStatus", "currentAgreement"],
  methods: {
    //取消
    handleClose() {
      this.ruleForm = {
        agreementName: "", //协议名称
        belongCustomerId: "", //客户id
        functionCode: "", //应用路径
        richTextContent: "", //富文本内容
        id: null,
        contentLink: "",
        agreementFlag: 0,
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //提交
    submit() {
      setTimeout(() => {
        this.ruleForm.belongCustomerId = this.platformData.id;
        this.ruleForm.appCode = this.platformData.appCode;
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if (this.dialogStatus == 0) {
              this.request.appAgreementAdd(this.ruleForm).then(() => {
                this.$emit("appAgreementList");
                this.$message.success(this.$t("pages.system.text53"));
                this.handleClose();
              });
            } else {
              this.request.appAgreementEdit(this.ruleForm).then(() => {
                this.$emit("appAgreementList");
                this.$message.success(this.$t("pages.system.text54"));
                this.handleClose();
              });
            }
          }
        });
      }, 500);
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
</style>